import React from "react";

import { Icon, IconProps } from "../";

export const NotificationIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 4.41746C10.9826 4.30787 11.485 4.25 12.0008 4.25C12.5161 4.25 13.0178 4.30773 13.5 4.41706V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.41746ZM5.99996 11C5.99996 7.68629 8.68625 5 12 5C15.3137 5 18 7.68629 18 11V14.7639C18 14.9192 18.0361 15.0723 18.1055 15.2111L19.2763 17.5528C19.6088 18.2177 19.1253 19 18.3819 19H5.61799C4.87461 19 4.39111 18.2177 4.72356 17.5528L5.89438 15.2111C5.96381 15.0723 5.99996 14.9192 5.99996 14.7639V11ZM12 22C13.1 22 14 21.1 14 20H9.99995C9.99995 21.1 10.89 22 12 22Z"
      />
    </Icon>
  );
};
